<div class="modal-column">
    <div class="log-in-form-block">
        <form (ngSubmit)="captchaRef.execute();" [formGroup]="form" novalidate>
            <h5>Lost your password?</h5>
            <p class="subtext">No worries, just enter the email registered to your Edgeless account.</p>
            <div class="spacer-10"></div>
            <app-form-input formControlName="email" type="email" title="Email address" data-id="modalForgot-email-input"></app-form-input>
            <app-form-button type="submit" class="primary full-width" data-id="modalForgot-reset-button">Reset password</app-form-button>
            <div class="log-in-or-text">Or</div>
            <a [routerLink]="['/', {outlets: {modal: 'login'}}]">
                <app-form-button type="button" class="full-width" data-id="modalForgot-login-button">Log in</app-form-button>
            </a>
          <re-captcha #captchaRef="reCaptcha" (resolved)="$event && requestPasswordReset($event)"></re-captcha>
        </form>
    </div>
    <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup" data-id="modalForgot-close-button">
        <i class="fal fa-times"></i>
    </a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/forgot-password/forgot-password-modal.template.html